import { render, staticRenderFns } from "./index3.8_2.vue?vue&type=template&id=d72080da&scoped=true"
import script from "./index3.8_2.vue?vue&type=script&lang=js"
export * from "./index3.8_2.vue?vue&type=script&lang=js"
import style0 from "./index3.8_2.vue?vue&type=style&index=0&id=d72080da&prod&lang=css"
import style1 from "./index3.8_2.vue?vue&type=style&index=1&id=d72080da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d72080da",
  null
  
)

export default component.exports